import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds,    FirstAds , MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
const TITLE = "Calculatrice de fraction - Simplification et calculs de fractions";
const DESCRIPTION =
  "Calculatrice de fraction - Simplification et calculs de fractions pour faire vos calculs mathematiques rapidement et sans erreur. Saisissez vos valeurs et obtenez un resultat immediat avec une methode simple a verifier.";
const KEYWORDS =
  "de fraction simplification et calculs de fractions, calculatrice de fraction simplification et calculs de fractions, calcul en ligne, mathematiques, pourcentage, formule, resultat rapide";
const OG_URL =
  "https://do-calculate.com/calculator/fr/fraction-simplifier/";
function FractionCalculator() {
  const [numerator, setNumerator] = useState("");
  const [denominator, setDenominator] = useState("");
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");
  const gcd = (a, b) => {
    return b === 0 ? a : gcd(b, a % b);
  };
  const handleCalculate = () => {
    try {
      if (!numerator || !denominator) {
        setError("Veuillez entrer le numérateur et le dénominateur");
        setResult(null);
        return;
      }
      const num = parseInt(numerator);
      const den = parseInt(denominator);
      if (den === 0) {
        setError("Le dénominateur ne peut pas être 0");
        setResult(null);
        return;
      }
      const divisor = gcd(Math.abs(num), Math.abs(den));
      const simplifiedNum = num / divisor;
      const simplifiedDen = den / divisor;
      const decimal = (num / den).toFixed(4);
      setResult({
        original: `${num}/${den}`,
        simplified: `${simplifiedNum}/${simplifiedDen}`,
        decimal: decimal
      });
      setError("");
    } catch (err) {
      setError("Erreur lors du calcul");
      setResult(null);
    }
  };
  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  La calculatrice de fraction vous aide à simplifier les fractions et effectuer des
                  calculs de fractions. Elle réduit automatiquement les fractions à leur forme la plus
                  simple en trouvant le plus grand diviseur commun (PGCD).
                </p>
                <p>
                  <strong>Utilisation:</strong> Entrez le numérateur et le dénominateur pour simplifier
                  votre fraction. La calculatrice affichera la forme simplifiée et l'équivalent décimal.
                </p>
                <ul>
                  <li>Simplification de fractions</li>
                  <li>Conversion en décimal</li>
                  <li>Calculs mathématiques rapides</li>
                </ul>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds/>
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div>
                  <div>
                    <hr />
                    <div className="form-group">
                      <label className="form-label ms-2">
                        Numérateur
                      </label>
                      <input
                        type="number"
                        value={numerator}
                        onChange={(e) => setNumerator(e.target.value)}
                        placeholder="Entrez le numérateur"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label ms-2">
                        Dénominateur
                      </label>
                      <input
                        type="number"
                        value={denominator}
                        onChange={(e) => setDenominator(e.target.value)}
                        placeholder="Entrez le dénominateur"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px" }}
                      onClick={handleCalculate}
                    >
                      Simplifier                    </button>
                  </div>
                  <br />
                  {error !== "" && (
                    <p className="p-3 mb-2 bg-warning text-black">
                      Erreur: {error}
                    </p>
                  )}
                  {result && (
                    <div className="p-3 mb-2 bg-success text-white">
                      <h4>Résultat:</h4>
                      <p>Fraction originale: {result.original}</p>
                      <p>Fraction simplifiée: <strong>{result.simplified}</strong></p>
                      <p>Équivalent décimal: {result.decimal}</p>
                    </div>
                  )}
                  <hr />
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
            <div className="row">
              <div className="col-sm-12 col-md-10">
                <div className="info-sections-container">
                  <div className="info-section">
                    <div className="info-section-header">
                      <h3 style={{ fontSize: "16px" }}>Calculatrice de fractions</h3>
                    </div>
                    <div className="info-section-body">
                      <p>
                        <strong>Qu'est-ce que la calculatrice de fractions ?</strong>
                        Cet outil permet d'effectuer les opérations de base sur les fractions :
                        addition, soustraction, multiplication et division.
                        Le résultat est automatiquement simplifié à sa forme la plus simple.
                      </p>
                      <p>
                        <strong>Comment utiliser :</strong>
                        Entrez le numérateur et le dénominateur de chaque fraction,
                        choisissez l'opération souhaitée, puis cliquez sur "Calculer".
                      </p>
                      <p>
                        <strong>Explication des résultats :</strong>
                        La calculatrice affiche le résultat sous forme de fraction simplifiée,
                        accompagné des étapes détaillées du calcul.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>

    </div>
  );
}
export default FractionCalculator;
